<template>
    <slot name="header">
        <h2>Title</h2>
        <p>Description</p>
    </slot>

    <div :class="['overview-layout', {'overview-layout--horizontal': horizontal}]">
        <div class="overview-layout__container">
            <overview-card v-for="(item, index) in items" :key="index" :item="item" :index="index"></overview-card>
        </div>

        <div class="overview-layout__footer">
            <slot name="footer">
                <h3>Text</h3>
                <button class="btn btn--primary">Button</button>
            </slot>
        </div>
    </div>
</template>

<script>
import OverviewCard from '@/components/game/OverviewCard.vue';

export default {
    name: 'OverviewLayout',
    props: ['items', 'horizontal'],
    components: {
        OverviewCard
    }
}
</script>
